import { render, staticRenderFns } from "./EWMerchantRegistrationRequestList.vue?vue&type=template&id=aef659ba&"
import script from "./EWMerchantRegistrationRequestList.vue?vue&type=script&lang=js&"
export * from "./EWMerchantRegistrationRequestList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports